// extracted by mini-css-extract-plugin
export default {"globalFrame":"ErrorPage_globalFrame__VQaQH","text":"ErrorPage_text__hyqiR","logo":"ErrorPage_logo__UTlK+","buttons":"ErrorPage_buttons__x42n7"};